/* eslint-disable react/no-access-state-in-setstate */
import React from "react";
import VALIDATIONS from "Constants/ValidationList";
import checkErrors from "Utils/InputValidator";
import AppConstants from "Constants/AppConstants";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import AuthBody from "../Common/AuthBody/AuthBody";
import PopupModal from "../Common/PopupModal/PopupModal";
import "./Compliance.scss";
import Stepper from "../Common/Stepper/Stepper";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";
import { isScanningAllowed } from "../../Utils/CommonUtilities";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import formatStringByPattern from "format-string-by-pattern";
import {
  allowKycEdit,
  allowKycEditForJointInSession,
  isNewMember,
  stepAlreadyProcessed,
} from "../../Utils/LogicUtilities";

class Compliance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accountPurpose: "",
      isThirdPartyAccount: "",
      isThirdPartyAccountProspect: false,
      thirdPartyName: "",
      thirdPartyRelationship: "",
      areYouPEPorHIO: "",
      areYouPEPorHIOProspect: false,
      memberPEPDomestic: false,
      memberPEPForeign: false,
      memberHIO: false,
      memberOfficeHeld: "",
      memberJurisdiction: "",
      memberFundsSource: "",
      isAnyoneConsideredPEPHIO: "",
      isAnyoneConsideredPEPHIOProspect: false,
      indicateName: "",
      anyRelationship: "",
      PEPDomestic: false,
      PEPForeign: false,
      HIO: false,
      jurisdictionType: "",
      anyOfficeHeld: "",
      anyJurisdiction: "",
      anySourceOfFunds: "",
      isThirdPartyAccountError: "",
      thirdPartyNameError: "",
      indicateNameError: "",
      accountPurposeError: "",
      thirdPartyRelationshipError: [],
      isMobile: false,
      showHelp: false,
      employerContactNumber: "",
      employerContactNumberError: [],
      employerPhoneSettings: {},
      occupationCode: "",
      occupationCodeSettings: {},
      occupationCodeError: [],
      sourceOfIncomeSettings: {},
      sourceOfIncome: "",
      sourceOfIncomeError: [],
    };
  }

  componentDidMount() {
    const { getDataFromServer } = this.props;

    this.checkPageSettings();

    getDataFromServer(AppConstants.APPLICATIONSTEP.COMPLIANCE, (response) => {
      this.setFormData(response);
    });
  }

  componentDidUpdate(prevProps) {
    const { finInfo } = this.props;
    if (finInfo !== prevProps.finInfo) {
      this.checkPageSettings();
    }
  }

  checkPageSettings() {
    const { finInfo } = this.props;
    const employerPhoneSettings = finInfo.config?.fieldSettings?.find(
      (item) => item.field === "employerPhone"
    );
    const occupationCodeSettings = finInfo.config?.fieldSettings?.find(
      (item) => item.field === "occupationCode"
    );
    const sourceOfIncomeSettings = finInfo.config?.fieldSettings?.find(
      (item) => item.field === "sourceOfIncome"
    );
    this.setState({
      employerPhoneSettings,
      occupationCodeSettings,
      sourceOfIncomeSettings,
    });
  }

  setFormData = (response) => {
    let { regulatory, member, peps, thirdParties, employment } = response.data;
    const {
      activeProduct,
      accountPurposeArray,
      processFlow,
      vaultMember,
      applicantData,
      finInfo,
      sessionCompletedProducts,
      inSessionJointApplicant,
    } = this.props;
    if (
      !activeProduct.prospect &&
      allowKycEdit(
        applicantData,
        sessionCompletedProducts,
        finInfo,
        inSessionJointApplicant
      )
    ) {
      regulatory.memberFundsSource = vaultMember.memberFundsSource;
      regulatory.memberHasThirdParty = vaultMember.memberHasThirdParty;
      regulatory.memberIsHio = vaultMember.memberIsHio;
      regulatory.memberIsPedp = vaultMember.memberIsPedp;
      regulatory.memberIsPefp = vaultMember.memberIsPefp;
      regulatory.memberJurisdiction = vaultMember.memberJurisdiction;
      regulatory.memberOfficeHeld = vaultMember.memberOfficeHeld;
      thirdParties = vaultMember.thirdParties;
      peps = vaultMember.peps;
      member.pep = vaultMember.pep;
    } else if (
      inSessionJointApplicant &&
      allowKycEditForJointInSession(applicantData, finInfo)
    ) {
      regulatory.memberFundsSource =
        inSessionJointApplicant.vault.memberFundsSource;
      regulatory.memberHasThirdParty =
        inSessionJointApplicant.vault.memberHasThirdParty;
      regulatory.memberIsHio = inSessionJointApplicant.vault.memberIsHio;
      regulatory.memberIsPedp = inSessionJointApplicant.vault.memberIsPedp;
      regulatory.memberIsPefp = inSessionJointApplicant.vault.memberIsPefp;
      regulatory.memberJurisdiction =
        inSessionJointApplicant.vault.memberJurisdiction;
      regulatory.memberOfficeHeld =
        inSessionJointApplicant.vault.memberOfficeHeld;
      thirdParties = inSessionJointApplicant.vault.thirdParties;
      peps = inSessionJointApplicant.vault.peps;
      member.pep = inSessionJointApplicant.vault.pep;
    }
    if (
      activeProduct.prospect?.id &&
      !stepAlreadyProcessed(
        AppConstants.APPLICATIONSTEP.COMPLIANCE,
        activeProduct.applicationStep.index,
        processFlow
      )
    ) {
      if (activeProduct.prospect.member?.intendedUseOfMembership) {
        const curr = accountPurposeArray.find(
          (e) =>
            e.code === activeProduct.prospect.member?.intendedUseOfMembership
        );
        if (curr) {
          member.intendedUseOfMembership =
            activeProduct.prospect.member?.intendedUseOfMembership;
        }
      }
      if (activeProduct.prospect.regulatory?.isThirdPartyAccount) {
        regulatory.isThirdPartyAccount =
          activeProduct.prospect.regulatory?.isThirdPartyAccount;
      }
      if (activeProduct.prospect.regulatory?.memberIsHio) {
        regulatory.memberIsHio = activeProduct.prospect.regulatory?.memberIsHio;
      }
      if (activeProduct.prospect.regulatory?.memberIsPedp) {
        regulatory.memberIsPedp =
          activeProduct.prospect.regulatory?.memberIsPedp;
      }
      if (activeProduct.prospect.regulatory?.memberIsPefp) {
        regulatory.memberIsPefp =
          activeProduct.prospect.regulatory?.memberIsPefp;
      }
      if (activeProduct.prospect.regulatory?.memberPEPDomestic) {
        regulatory.memberPEPDomestic =
          activeProduct.prospect.regulatory?.memberPEPDomestic;
      }
      if (activeProduct.prospect.regulatory?.memberPEPForeign) {
        regulatory.memberPEPForeign =
          activeProduct.prospect.regulatory?.memberPEPForeign;
      }
      if (activeProduct.prospect.regulatory?.memberHIO) {
        regulatory.memberHIO = activeProduct.prospect.regulatory?.memberHIO;
      }
      if (activeProduct.prospect.regulatory?.memberOfficeHeld) {
        regulatory.memberOfficeHeld =
          activeProduct.prospect.regulatory?.memberOfficeHeld;
      }
      if (activeProduct.prospect.regulatory?.memberJurisdiction) {
        regulatory.memberJurisdiction =
          activeProduct.prospect.regulatory?.memberJurisdiction;
      }
      if (activeProduct.prospect.regulatory?.memberFundsSource) {
        regulatory.memberFundsSource =
          activeProduct.prospect.regulatory?.memberFundsSource;
      }
      if (activeProduct.prospect.PEPs) {
        peps = activeProduct.prospect.PEPs;
      }
      if (activeProduct.prospect.thirdParties) {
        thirdParties = activeProduct.prospect.thirdParties;
      }
      if (activeProduct.prospect.employment?.employerPhoneArea) {
        employment.employerPhoneArea =
          activeProduct.prospect.employment.employerPhoneArea;
        employment.employerPhone =
          activeProduct.prospect.employment.employerPhone;
      }
      if (activeProduct.prospect.employment?.occupationCode) {
        employment.occupationCode =
          activeProduct.prospect.employment.occupationCode;
      }
      if (activeProduct.prospect.employment?.incomeType) {
        employment.incomeType = activeProduct.prospect.employment.incomeType;
      }
    }
    console.log(
      "setFormData",
      employment.employerPhoneArea + employment.employerPhone
    );
    const jurisdictionType = peps ? peps[0]?.jurisdictionType : "";
    this.setState({
      accountPurpose: member?.intendedUseOfMembership || "",
      isThirdPartyAccount: !!regulatory?.memberHasThirdParty,
      isThirdPartyAccountProspect:
        activeProduct.prospect?.regulatory?.memberHasThirdParty,
      thirdPartyName:
        thirdParties && thirdParties[0]?.name ? thirdParties[0]?.name : "",
      thirdPartyRelationship:
        thirdParties && thirdParties[0]?.relationship
          ? thirdParties[0]?.relationship
          : "",
      areYouPEPorHIO:
        !!regulatory?.memberIsHio ||
        !!regulatory?.memberIsPedp ||
        !!regulatory?.memberIsPefp,
      areYouPEPorHIOProspect:
        !!activeProduct.prospect?.regulatory?.memberIsHio ||
        !!activeProduct.prospect?.regulatory?.memberIsPedp ||
        !!activeProduct.prospect?.regulatory?.memberIsPefp,
      memberPEPDomestic: regulatory?.memberIsPedp || false,
      memberPEPForeign: regulatory?.memberIsPefp || false,
      memberHIO: regulatory?.memberIsHio || false,
      memberOfficeHeld: regulatory?.memberOfficeHeld || "",
      memberJurisdiction: regulatory?.memberJurisdiction || "",
      memberFundsSource: regulatory?.memberFundsSource || "",
      isAnyoneConsideredPEPHIO: !!(peps && peps.length > 0),
      isAnyoneConsideredPEPHIOProspect: !!(
        activeProduct.prospect?.PEPs && activeProduct.prospect?.PEPs.length > 0
      ),
      indicateName: peps && peps[0]?.name ? peps[0]?.name : "",
      anyRelationship:
        peps && peps[0]?.relationship ? peps[0]?.relationship : "",
      PEPDomestic:
        jurisdictionType ===
          AppConstants.COMPLIANCE.JURISDICTION_TYPE.DOMESTIC || "",
      PEPForeign:
        jurisdictionType ===
          AppConstants.COMPLIANCE.JURISDICTION_TYPE.FOREIGN || "",
      HIO: peps && peps[0]?.hio ? peps[0]?.hio : "",
      jurisdictionType:
        peps && peps[0]?.jurisdictionType ? peps[0]?.jurisdictionType : "",
      anyOfficeHeld: peps && peps[0]?.officeHeld ? peps[0]?.officeHeld : "",
      anyJurisdiction:
        peps && peps[0]?.jurisdiction ? peps[0]?.jurisdiction : "",
      anySourceOfFunds:
        peps && peps[0]?.fundsSource ? peps[0]?.fundsSource : "",
      employerContactNumber:
        employment.employerPhoneArea + employment.employerPhone,
      occupationCode: employment ? employment.occupationCode : "",
      isMobile: isScanningAllowed(),
      sourceOfIncome: employment ? employment.incomeType : "",
    });
  };

  handleBack = () => {
    const { handleBack } = this.props;
    handleBack(AppConstants.APPLICATIONSTEP.COMPLIANCE);
  };

  changeHandler = (event) => {
    const complianceData = this.state;
    const inputField = event?.target.name;
    let eventValue = event?.target.value;

    // Fields that need to have capitalized words
    const capitalizeFields = [
      "thirdPartyName",
      "memberJurisdiction",
      "memberFundsSource",
      "indicateName",
      "anyJurisdiction",
      "anySourceOfFunds",
    ];

    // If the input field requires capitalization, apply the logic
    if (eventValue && capitalizeFields.includes(inputField)) {
      eventValue = eventValue
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize only the first letter
        .join(" ");

      // Also remove any invalid characters for specific fields
      if (inputField === "thirdPartyName" || inputField === "indicateName") {
        eventValue = eventValue.replace(
          /[^A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð\. \-']/gi,
          ""
        );
      }
    }

    complianceData[event.target.name] = eventValue;
    complianceData[`${event.target.name}Error`] = "";
    this.setState({ complianceData });
  };

  handleChoice = (name, choice) => {
    console.log("handleChoice", name, choice);
    const complianceData = this.state;
    complianceData[name] = choice;
    if (choice === false) {
      if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.ISTHIRDPARTACCOUNT) {
        this.setState({
          thirdPartyNameError: [],
          thirdPartyRelationshipError: [],
        });
        complianceData.thirdPartyName = "";
        complianceData.thirdPartyRelationship = "";
      }
    }
    this.setState({ complianceData });

    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.ISTHIRDPARTACCOUNT) {
      this.setState({ isThirdPartyAccountError: [] });
    }
  };

  handleMemberPEPHIOChoice = (name) => {
    console.log("handleMemberPEPHIOChoice", name);
    const { memberPEPDomestic, memberPEPForeign, memberHIO } = this.state;
    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERPEPDOMESTIC) {
      this.setState({
        memberPEPDomestic: !memberPEPDomestic,
        memberTypeError: [],
      });
    }
    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERPEPFOREIGN) {
      this.setState({
        memberPEPForeign: !memberPEPForeign,
        memberTypeError: [],
      });
    }
    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERHIO) {
      this.setState({
        memberHIO: !memberHIO,
        memberTypeError: [],
      });
    }
  };

  handlePEPHIOChoice = (name) => {
    console.log("handlePEPHIOChoice", name);
    const { PEPDomestic, PEPForeign, HIO } = this.state;
    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.PEPDOMESTIC) {
      this.setState({
        PEPDomestic: !PEPDomestic,
        PEPForeign: false,
        anyTypeError: [],
      });
    } else if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.PEPFOREIGN) {
      this.setState({
        PEPDomestic: false,
        PEPForeign: !PEPForeign,
        anyTypeError: [],
      });
    }
    if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.HIO) {
      this.setState({
        HIO: !HIO,
        anyTypeError: [],
      });
    }
  };

  handlePEPChoice = (name, choice) => {
    console.log("handlePEPChoice", name, choice);
    const complianceData = this.state;
    complianceData[name] = choice;
    if (choice === false) {
      if (name === STRINGS.COMPLIANCE.FORM.FIELDNAME.AREYOUPEPORHIO) {
        this.setState({
          memberPEPDomestic: false,
          memberPEPForeign: false,
          memberHIO: false,
          memberTypeError: [],
          memberFundsSourceError: [],
          memberJurisdictionError: [],
          memberOfficeHeldError: [],
        });
        complianceData.memberOfficeHeld = "";
        complianceData.memberJurisdiction = "";
        complianceData.memberFundsSource = "";
      }
      if (
        name === STRINGS.COMPLIANCE.FORM.FIELDNAME.ISANYONECONSIDEREDPEPORHIO
      ) {
        this.setState({
          PEPDomestic: false,
          PEPForeign: false,
          HIO: false,
          indicateNameError: [],
          anyRelationshipError: [],
          anyTypeError: [],
          anyOfficeHeldError: [],
          anyJurisdictionError: [],
          anySourceOfFundsError: [],
        });
        complianceData.anyOfficeHeld = "";
        complianceData.anyJurisdiction = "";
        complianceData.anySourceOfFunds = "";
        complianceData.indicateName = "";
        complianceData.anyRelationship = "";
      }
    }
    this.setState({ complianceData });
  };

  handleSubmit = (e) => {
    console.log("handleSubmit", e);
    const { handleUpdateComplianceData } = this.props;

    e.preventDefault();

    const formIsValid = this.verifyData();
    if (formIsValid) {
      const formdata = this.state;
      handleUpdateComplianceData(formdata);
    }
  };

  verifyData = () => {
    let formIsValid = true;
    const {
      isThirdPartyAccount,
      thirdPartyName,
      accountPurpose,
      thirdPartyRelationship,
      areYouPEPorHIO,
      memberPEPDomestic,
      memberPEPForeign,
      memberHIO,
      memberOfficeHeld,
      memberJurisdiction,
      memberFundsSource,
      isAnyoneConsideredPEPHIO,
      indicateName,
      anyRelationship,
      PEPDomestic,
      PEPForeign,
      HIO,
      anyOfficeHeld,
      anyJurisdiction,
      anySourceOfFunds,
    } = this.state;
    const { finInfo, applicantData } = this.props;
    let thirdPartyNameRes = "";
    let indicateNameRes = "";
    let thirdPartyRelationshipError = [];
    let memberTypeError = [];
    let memberOfficeHeldError = [];
    let memberJurisdictionError = [];
    let memberFundsSourceError = [];
    let anyRelationshipError = [];
    let anyTypeError = [];
    let anyOfficeHeldError = [];
    let anyJurisdictionError = [];
    let anySourceOfFundsError = [];

    const isThirdPartyAccountRes = checkErrors(
      isThirdPartyAccount,
      VALIDATIONS.COMPLIANCE.isThirdPartyAccount
    );

    this.setState({
      isThirdPartyAccountError: isThirdPartyAccountRes,
    });

    if (isThirdPartyAccount) {
      thirdPartyNameRes = checkErrors(
        thirdPartyName,
        VALIDATIONS.COMPLIANCE.thirdPartyName
      );
      this.setState({
        thirdPartyNameError: thirdPartyNameRes,
      });

      thirdPartyRelationshipError = checkErrors(
        thirdPartyRelationship,
        VALIDATIONS.COMPLIANCE.RELATIONSHIP
      );
      this.setState({ thirdPartyRelationshipError });
    }

    if (areYouPEPorHIO) {
      memberTypeError =
        !memberPEPDomestic && !memberPEPForeign && !memberHIO
          ? ["Please select type"]
          : [];

      memberOfficeHeldError = checkErrors(
        memberOfficeHeld,
        VALIDATIONS.COMPLIANCE.OFFICE_HELD
      );

      memberJurisdictionError = checkErrors(
        memberJurisdiction,
        VALIDATIONS.COMPLIANCE.JURISDICTION
      );

      memberFundsSourceError = checkErrors(
        memberFundsSource,
        VALIDATIONS.COMPLIANCE.SOURCE_OF_FUNDS
      );

      this.setState({
        memberTypeError,
        memberOfficeHeldError,
        memberJurisdictionError,
        memberFundsSourceError,
      });
    }

    if (isAnyoneConsideredPEPHIO) {
      indicateNameRes = checkErrors(
        indicateName,
        VALIDATIONS.COMPLIANCE.indicateName
      );

      anyRelationshipError = checkErrors(
        anyRelationship,
        VALIDATIONS.COMPLIANCE.RELATIONSHIP
      );

      anyTypeError =
        !PEPDomestic && !PEPForeign && !HIO ? ["Please select type"] : [];

      anyOfficeHeldError = checkErrors(
        anyOfficeHeld,
        VALIDATIONS.COMPLIANCE.OFFICE_HELD
      );

      anyJurisdictionError = checkErrors(
        anyJurisdiction,
        VALIDATIONS.COMPLIANCE.JURISDICTION
      );

      anySourceOfFundsError = checkErrors(
        anySourceOfFunds,
        VALIDATIONS.COMPLIANCE.SOURCE_OF_FUNDS
      );

      this.setState({
        indicateNameError: indicateNameRes,
        anyRelationshipError,
        anyTypeError,
        anyOfficeHeldError,
        anyJurisdictionError,
        anySourceOfFundsError,
      });
    }

    if (
      isThirdPartyAccountRes.length > 0 ||
      thirdPartyNameRes.length > 0 ||
      indicateNameRes.length > 0 ||
      thirdPartyRelationshipError.length > 0 ||
      memberTypeError.length > 0 ||
      memberOfficeHeldError.length > 0 ||
      memberJurisdictionError.length > 0 ||
      memberFundsSourceError.length > 0 ||
      anyTypeError.length > 0 ||
      anyOfficeHeldError.length > 0 ||
      anyJurisdictionError.length > 0 ||
      anySourceOfFundsError.length > 0
    ) {
      formIsValid = false;
    }

    if (finInfo.showMembershipPurpose && isNewMember(applicantData)) {
      const accountPurposeError = checkErrors(
        accountPurpose,
        VALIDATIONS.COMPLIANCE.selectAccountPurpose
      );
      if (accountPurposeError.length > 0) {
        formIsValid = false;
      }
      this.setState({ accountPurposeError });
    }
    console.log("validation result", formIsValid, this.state);
    return formIsValid;
  };

  handleCloseHelp = () => {
    this.setState({
      showHelp: false,
    });
  };

  handleOpenHelp = (text) => {
    console.log("handleOpenHelp");
    this.setState({
      showHelp: true,
      helpText: text,
    });
  };

  render() {
    const {
      accountPurpose,
      isThirdPartyAccount,
      isThirdPartyAccountProspect,
      thirdPartyName,
      thirdPartyRelationship,
      areYouPEPorHIO,
      areYouPEPorHIOProspect,
      memberPEPDomestic,
      memberPEPForeign,
      memberHIO,
      memberOfficeHeld,
      memberJurisdiction,
      memberFundsSource,
      isAnyoneConsideredPEPHIO,
      isAnyoneConsideredPEPHIOProspect,
      indicateName,
      anyRelationship,
      PEPDomestic,
      PEPForeign,
      HIO,
      anyOfficeHeld,
      anyJurisdiction,
      anySourceOfFunds,
      isThirdPartyAccountError,
      thirdPartyNameError,
      indicateNameError,
      accountPurposeError,
      thirdPartyRelationshipError,
      memberTypeError,
      memberOfficeHeldError,
      memberJurisdictionError,
      memberFundsSourceError,
      anyRelationshipError,
      anyTypeError,
      anyOfficeHeldError,
      anyJurisdictionError,
      anySourceOfFundsError,
      showHelp,
      helpText,
      employerPhoneSettings,
      employerContactNumber,
      employerContactNumberError,
      occupationCodeSettings,
      occupationCode,
      occupationCodeError,
      sourceOfIncomeSettings,
      sourceOfIncome,
      sourceOfIncomeError,
    } = this.state;

    const {
      accountPurposeArray,
      indicateWhoArray,
      showModal,
      type,
      modal,
      toggleModal,
      steps,
      activeStepID,
      occupationCodes,
      incomeSourcesList,
      finInfo,
      activeProduct,
      applicantData,
      contKycFlag,
    } = this.props;

    const actionComponent = (
      <div className="[ compliance-container ]">
        {showModal && (
          <PopupModal
            type={type}
            title={modal.title}
            description={modal.description}
            toggleModal={toggleModal}
            showModal={showModal}
            popupBtnClick={
              type === AppConstants.MODALTYPE.SUCCESS
                ? this.handlePopupModalBtnClick
                : () => {}
            }
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}

        <Stepper steps={steps} active={activeStepID} />

        <div className="[ form-title ]">{STRINGS.COMPLIANCE.TITLE}</div>

        <div className="[ form-container ]">
          {!isNewMember(applicantData) && (
            <div className="[ mb-3 ]">
              <div className="[ form-subtitle ]">
                {STRINGS.COMPLIANCE.SUBTITLE_MEMBER}
              </div>
            </div>
          )}
          {finInfo.showMembershipPurpose && isNewMember(applicantData) && (
            <div className="[ mb-3 ]">
              <div className="[ form-label ]">
                {STRINGS.COMPLIANCE.FORM.ACCOUNT_PURPOSE_LABEL}
              </div>
              <select
                className={
                  accountPurposeError && accountPurposeError.length > 0
                    ? "[ form-control ] [ invalid-input ] [ select__dropdown ]"
                    : "[ form-control ] [ select__dropdown ]"
                }
                id="exampleFormControlSelect1"
                name="accountPurpose"
                placeholder={
                  STRINGS.COMPLIANCE.FORM.ACCOUNT_PURPOSE_PLACEHOLDER
                }
                value={accountPurpose}
                disabled={
                  !!activeProduct?.prospect?.member?.intendedUseOfMembership &&
                  !!accountPurposeArray.find(
                    (e) =>
                      e.code ===
                      activeProduct.prospect?.member?.intendedUseOfMembership
                  )
                }
                onChange={this.changeHandler}
              >
                <option value="" className="[ default ] [ dropdown__option ]">
                  {STRINGS.COMPLIANCE.FORM.ACCOUNT_PURPOSE_PLACEHOLDER}
                </option>
                {accountPurposeArray?.map((obj) => {
                  return (
                    <option key={obj.code} value={obj.code}>
                      {obj.description}
                    </option>
                  );
                })}
              </select>
              <div className="[ error-msg ] ">{accountPurposeError[0]}</div>
            </div>
          )}

          {employerPhoneSettings?.page ===
            AppConstants.APPLICATIONSTEP.COMPLIANCE && (
            <div className="[ mb-3 ]">
              <div className="[ form-label ]">
                {STRINGS.EMPLOYMENT_AND_INCOME.FORM.EMPLOYER_WORK_PHONE}
              </div>
              <NumberFormat
                format={AppConstants.EMPLOYMENTANDINCOME.NUMBERFORMAT}
                className="[ form-control ]"
                type="text"
                name="employerContactNumber"
                value={employerContactNumber}
                disabled={!!activeProduct.prospect?.employment?.employerPhone}
                placeholder={`${STRINGS.EMPLOYMENT_AND_INCOME.FORM.PLACEHOLDER.EMPLOYER_CONTACT_NO}`}
                onChange={this.changeHandler}
              />
              <div className="[ error-msg ]">
                {employerContactNumberError && (
                  <>{employerContactNumberError}</>
                )}
              </div>
            </div>
          )}

          {occupationCodeSettings?.page ===
            AppConstants.APPLICATIONSTEP.COMPLIANCE && (
            <div className="[ mb-3 ]">
              <div className="[ form-label ]">
                {STRINGS.EMPLOYMENT_AND_INCOME.FORM.OCCUPATION}
              </div>
              <select
                className="[ form-control select__dropdown]"
                id="occupationCode"
                name="occupationCode"
                value={occupationCode}
                disabled={!!activeProduct.prospect?.employment?.occupationCode}
                placeholder={
                  STRINGS.EMPLOYMENT_AND_INCOME.FORM.PLACEHOLDER.OCCUPATION
                }
                onChange={this.changeHandler}
              >
                <option value="" className="[ default ] [ dropdown__option ]">
                  {STRINGS.EMPLOYMENT_AND_INCOME.FORM.PLACEHOLDER.OCCUPATION}
                </option>
                {occupationCodes
                  ? occupationCodes.map((occupation) => (
                      <option
                        key={occupation.code}
                        value={occupation.code}
                        className="[ dropdown__option ]"
                      >
                        {occupation.description}
                      </option>
                    ))
                  : ""}
              </select>
              <div className="[ error-msg ]">
                {occupationCodeError && <>{occupationCodeError}</>}
              </div>
            </div>
          )}

          {sourceOfIncomeSettings?.page ===
            AppConstants.APPLICATIONSTEP.COMPLIANCE && (
            <div className="[ mb-3 ]">
              <div className="[ form-label ]">
                {STRINGS.EMPLOYMENT_AND_INCOME.FORM.SOURCE_OF_INCOME}
              </div>
              <select
                className="[ form-control select__dropdown]"
                id="sourceOfIncome"
                name="sourceOfIncome"
                value={sourceOfIncome}
                disabled={!!activeProduct.prospect?.employment?.incomeType}
                onChange={this.changeHandler}
                placeholder={
                  STRINGS.EMPLOYMENT_AND_INCOME.FORM.PLACEHOLDER
                    .EMPLOYMENT_STATUS
                }
              >
                <option value="" className="[ default ] [ dropdown__option ]">
                  {
                    STRINGS.EMPLOYMENT_AND_INCOME.FORM.PLACEHOLDER
                      .SOURCE_OF_INCOME
                  }
                </option>
                {incomeSourcesList
                  ? incomeSourcesList.map((incomeSource) => (
                      <option
                        key={incomeSource.code}
                        value={incomeSource.code}
                        className="[ dropdown__option ]"
                      >
                        {incomeSource.description}
                      </option>
                    ))
                  : ""}
              </select>
              <div className="[ error-msg ]">
                {sourceOfIncomeError && <>{sourceOfIncomeError}</>}
              </div>
            </div>
          )}

          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.COMPLIANCE.FORM.THIRDPARTY_ACCOUNT}
              {!contKycFlag ? (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(STRINGS.COMPLIANCE.HELP.THIRD_PARTY)
                  }
                />
              ) : (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(STRINGS.COMPLIANCE.HELP.THIRD_PARTY_KYC)
                  }
                />
              )}
            </div>

            <div className="[ row ] [ custom-radios ]">
              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    isThirdPartyAccount
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={isThirdPartyAccountProspect}
                  onClick={() =>
                    this.handleChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME.ISTHIRDPARTACCOUNT,
                      true
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.YES}
                </button>
              </div>

              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    !isThirdPartyAccount
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={isThirdPartyAccountProspect}
                  onClick={() =>
                    this.handleChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME.ISTHIRDPARTACCOUNT,
                      false
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.NO}
                </button>
              </div>
            </div>
            <div className="[ error-msg ]">{isThirdPartyAccountError}</div>

            {isThirdPartyAccount ? (
              <div className="[ drawer-content-container ]">
                <div className="[ info-title ]">
                  {STRINGS.COMPLIANCE.FORM.THIRDPARTY_TITLE}
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.THIRDPARTY_NAME}
                  </div>
                  <input
                    type="text"
                    id="thirdPartyName"
                    name="thirdPartyName"
                    className={
                      thirdPartyNameError.length > 0
                        ? "[ form-control ] [ invalid-input ]"
                        : "[ form-control ]"
                    }
                    disabled={
                      isThirdPartyAccountProspect &&
                      activeProduct.prospect?.thirdParties &&
                      activeProduct.prospect?.thirdParties[0]?.name
                    }
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.THIRDPARTY_NAME_PLACEHOLDER
                    }
                    value={thirdPartyName}
                    onChange={this.changeHandler}
                  />
                  <div className="[ error-msg ] ">{thirdPartyNameError}</div>
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.THIRDPARTY_RELATIONSHIP}
                  </div>
                  <select
                    className="[ form-control ] [ select__dropdown ]"
                    disabled={
                      isThirdPartyAccountProspect &&
                      activeProduct.prospect?.thirdParties &&
                      activeProduct.prospect?.thirdParties[0]?.relationship
                    }
                    id="thirdPartyRelationship"
                    name="thirdPartyRelationship"
                    value={thirdPartyRelationship}
                    onChange={this.changeHandler}
                  >
                    <option
                      value=""
                      className="[ default ] [ dropdown__option ]"
                    >
                      {
                        STRINGS.COMPLIANCE.FORM
                          .THIRDPARTY_RELATIONSHIP_PLACEHOLDER
                      }
                    </option>
                    {indicateWhoArray?.map((obj) => {
                      return (
                        <option
                          key={obj.code}
                          value={obj.description}
                          className="[ dropdown__option ]"
                        >
                          {obj.description}
                        </option>
                      );
                    })}
                  </select>
                  <div className="[ error-msg ] ">
                    {thirdPartyRelationshipError}
                  </div>
                </div>
              </div>
            ) : null}
          </div>

          {/* Start PEP block */}
          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.COMPLIANCE.FORM.MEMBER_PEP_HIO_CHOICE}
              {!contKycFlag ? (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(STRINGS.COMPLIANCE.HELP.MEMBER_PEP_HIO)
                  }
                />
              ) : (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(
                      STRINGS.COMPLIANCE.HELP.MEMBER_PEP_HIO_KYC
                    )
                  }
                />
              )}
            </div>

            <div className="[ row ] [ custom-radios ]">
              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    areYouPEPorHIO
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={areYouPEPorHIOProspect}
                  onClick={() =>
                    this.handlePEPChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME.AREYOUPEPORHIO,
                      true
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.YES}
                </button>
              </div>

              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    !areYouPEPorHIO
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={areYouPEPorHIOProspect}
                  onClick={() =>
                    this.handlePEPChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME.AREYOUPEPORHIO,
                      false
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.NO}
                </button>
              </div>
            </div>
            <div className="[ error-msg ]" />
            {/* Start PEP Inner block */}
            {areYouPEPorHIO ? (
              <div className="[ drawer-content-container ]">
                <div className="[ info-title ]">
                  {STRINGS.COMPLIANCE.FORM.PERSON_TITLE}
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.HOI_CHOICE}
                  </div>

                  <div className="[ row ] [ custom-radios ]">
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          memberPEPDomestic
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={areYouPEPorHIOProspect}
                        onClick={() =>
                          this.handleMemberPEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERPEPDOMESTIC
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.PEP_DOMESTIC}
                      </button>
                    </div>
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          memberPEPForeign
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={areYouPEPorHIOProspect}
                        onClick={() =>
                          this.handleMemberPEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERPEPFOREIGN
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.PEP_FOREIGN}
                      </button>
                    </div>
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          memberHIO
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={areYouPEPorHIOProspect}
                        onClick={() =>
                          this.handleMemberPEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.MEMBERHIO
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.HOI}
                      </button>
                    </div>
                    <div className="[ col-12 ]">
                      <div className="[ error-msg ] ">{memberTypeError}</div>
                    </div>
                  </div>
                </div>

                {finInfo.config.officeHeld && (
                  <div className="[ mb-3 ]">
                    <div className="[ form-label ]">
                      {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_LABEL}
                    </div>
                    <select
                      className="[ form-control ] [ select__dropdown ]"
                      disabled={
                        areYouPEPorHIOProspect &&
                        activeProduct.prospect?.regulatory?.memberOfficeHeld
                      }
                      id="memberOfficeHeld"
                      name="memberOfficeHeld"
                      value={memberOfficeHeld}
                      onChange={this.changeHandler}
                    >
                      <option
                        value=""
                        className="[ default ] [ dropdown__option ]"
                      >
                        {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_PLACEHOLDER}
                      </option>
                      {finInfo.config.officeHeld?.map((obj) => {
                        return (
                          <option
                            key={obj.code}
                            value={obj.code}
                            className="[ dropdown__option ]"
                          >
                            {obj.description}
                          </option>
                        );
                      })}
                    </select>
                    <div className="[ error-msg ] ">
                      {memberOfficeHeldError}
                    </div>
                  </div>
                )}

                {!finInfo.config.officeHeld && (
                  <div className="[ mb-3 ]">
                    <div className="[ form-label ]">
                      {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_LABEL}
                    </div>
                    <input
                      type="text"
                      id="memberOfficeHeld"
                      name="memberOfficeHeld"
                      className="form-control"
                      disabled={
                        areYouPEPorHIOProspect &&
                        activeProduct.prospect?.regulatory?.memberOfficeHeld
                      }
                      placeholder={
                        STRINGS.COMPLIANCE.FORM.OFFICE_HELD_PLACEHOLDER
                      }
                      value={memberOfficeHeld}
                      onChange={(event) => this.changeHandler(event)}
                    />
                    <div className="[ error-msg ] ">
                      {memberOfficeHeldError}
                    </div>
                  </div>
                )}

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.JURISDICTION_LABEL}
                  </div>
                  <input
                    type="text"
                    id="memberJurisdiction"
                    name="memberJurisdiction"
                    className="form-control"
                    disabled={
                      areYouPEPorHIOProspect &&
                      activeProduct.prospect?.regulatory?.memberJurisdiction
                    }
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.JURISDICTION_PLACEHOLDER
                    }
                    value={memberJurisdiction}
                    onChange={(event) => this.changeHandler(event)}
                  />
                  <div className="[ error-msg ] ">
                    {memberJurisdictionError}
                  </div>
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.SOURCE_OF_FUNDS_LABEL}
                  </div>
                  <input
                    type="text"
                    id="memberFundsSource"
                    name="memberFundsSource"
                    className="form-control"
                    disabled={
                      areYouPEPorHIOProspect &&
                      activeProduct.prospect?.regulatory?.memberFundsSource
                    }
                    maxLength={40}
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.SOURCE_OF_FUNDS_PLACEHOLDER
                    }
                    value={memberFundsSource}
                    onChange={(event) => this.changeHandler(event)}
                  />
                  <div className="[ error-msg ] ">{memberFundsSourceError}</div>
                </div>
              </div>
            ) : null}

            {/* End PEP Inner block */}
            {/* End PEP block */}
          </div>

          {/* Start HIO block */}

          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.COMPLIANCE.FORM.PEP_HIO_CHOICE}
              {!contKycFlag ? (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(STRINGS.COMPLIANCE.HELP.ANY_PEP_HIO)
                  }
                />
              ) : (
                <QuestionCircle
                  className="question-icon"
                  size={20}
                  onClick={() =>
                    this.handleOpenHelp(STRINGS.COMPLIANCE.HELP.ANY_PEP_HIO_KYC)
                  }
                />
              )}
            </div>

            <div className="[ row ] [ custom-radios ]">
              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    isAnyoneConsideredPEPHIO
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={isAnyoneConsideredPEPHIOProspect}
                  onClick={() =>
                    this.handlePEPChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME
                        .ISANYONECONSIDEREDPEPORHIO,
                      true
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.YES}
                </button>
              </div>

              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    isAnyoneConsideredPEPHIO === false
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  disabled={isAnyoneConsideredPEPHIOProspect}
                  onClick={() =>
                    this.handlePEPChoice(
                      STRINGS.COMPLIANCE.FORM.FIELDNAME
                        .ISANYONECONSIDEREDPEPORHIO,
                      false
                    )
                  }
                >
                  {STRINGS.COMMON.CHOICE.NO}
                </button>
              </div>
              <div className="[ error-msg ]" />
            </div>
            {/* Start HIO inner block */}

            {isAnyoneConsideredPEPHIO ? (
              <div className="[ drawer-content-container ]">
                <div className="[ info-title ]">
                  {STRINGS.COMPLIANCE.FORM.PERSON_TITLE}
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.PERSON_NAME}
                  </div>
                  <input
                    type="text"
                    id="indicateName"
                    name="indicateName"
                    className={
                      indicateNameError.length > 0
                        ? "[ form-control ] [ invalid-input ]"
                        : "[ form-control ]"
                    }
                    disabled={
                      isAnyoneConsideredPEPHIOProspect &&
                      activeProduct.prospect?.PEPs[0].name
                    }
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.PERSON_NAME_PLACEHOLDER
                    }
                    value={indicateName}
                    onChange={this.changeHandler}
                  />
                  <div className="[ error-msg ]">{indicateNameError}</div>
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.THIRDPARTY_RELATIONSHIP}
                  </div>
                  <select
                    className="[ form-control ] [ select__dropdown ]"
                    disabled={
                      isAnyoneConsideredPEPHIOProspect &&
                      activeProduct.prospect?.PEPs[0].relationship
                    }
                    id="anyRelationship"
                    name="anyRelationship"
                    value={anyRelationship}
                    onChange={this.changeHandler}
                  >
                    <option
                      value=""
                      className="[ default ] [ dropdown__option ]"
                    >
                      {
                        STRINGS.COMPLIANCE.FORM
                          .THIRDPARTY_RELATIONSHIP_PLACEHOLDER
                      }
                    </option>
                    {indicateWhoArray?.map((obj) => {
                      return (
                        <option
                          key={obj.code}
                          value={obj.description}
                          className="[ dropdown__option ]"
                        >
                          {obj.description}
                        </option>
                      );
                    })}
                  </select>
                  <div className="[ error-msg ] ">{anyRelationshipError}</div>
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.HOI_CHOICE}
                  </div>
                  <div className="[ row ] [ custom-radios ]">
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          PEPDomestic
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={
                          isAnyoneConsideredPEPHIOProspect &&
                          activeProduct.prospect?.PEPs[0].jurisdictionType &&
                          activeProduct.prospect?.PEPs[0].HIO
                        }
                        onClick={() =>
                          this.handlePEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.PEPDOMESTIC
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.PEP_DOMESTIC}
                      </button>
                    </div>
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          PEPForeign
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={
                          isAnyoneConsideredPEPHIOProspect &&
                          activeProduct.prospect?.PEPs[0].jurisdictionType &&
                          activeProduct.prospect?.PEPs[0].HIO
                        }
                        onClick={() =>
                          this.handlePEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.PEPFOREIGN
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.PEP_FOREIGN}
                      </button>
                    </div>
                    <div className="[ col-md-4 col-12 ]">
                      <button
                        type="button"
                        className={
                          HIO
                            ? "[ btn custom-radio-selected ]"
                            : "[ btn custom-radio-unselected ]"
                        }
                        disabled={
                          isAnyoneConsideredPEPHIOProspect &&
                          activeProduct.prospect?.PEPs[0].jurisdictionType &&
                          activeProduct.prospect?.PEPs[0].HIO
                        }
                        onClick={() =>
                          this.handlePEPHIOChoice(
                            STRINGS.COMPLIANCE.FORM.FIELDNAME.HIO
                          )
                        }
                      >
                        {STRINGS.COMPLIANCE.CHOICE.HOI}
                      </button>
                    </div>
                  </div>
                  <div className="[col-12]">
                    <div className="[ error-msg ] ">{anyTypeError}</div>
                  </div>
                </div>

                {finInfo.config.officeHeld && (
                  <div className="[ mb-3 ]">
                    <div className="[ form-label ]">
                      {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_LABEL}
                    </div>
                    <select
                      className="[ form-control ] [ select__dropdown ]"
                      disabled={
                        isAnyoneConsideredPEPHIOProspect &&
                        activeProduct.prospect?.PEPs[0].officeHeld
                      }
                      id="anyOfficeHeld"
                      name="anyOfficeHeld"
                      value={anyOfficeHeld}
                      onChange={this.changeHandler}
                    >
                      <option
                        value=""
                        className="[ default ] [ dropdown__option ]"
                      >
                        {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_PLACEHOLDER}
                      </option>
                      {finInfo.config.officeHeld?.map((obj) => {
                        return (
                          <option
                            key={obj.code}
                            value={obj.code}
                            className="[ dropdown__option ]"
                          >
                            {obj.description}
                          </option>
                        );
                      })}
                    </select>
                    <div className="[ error-msg ] ">{anyOfficeHeldError}</div>
                  </div>
                )}

                {!finInfo.config.officeHeld && (
                  <div className="[ mb-3 ]">
                    <div className="[ form-label ]">
                      {STRINGS.COMPLIANCE.FORM.OFFICE_HELD_LABEL}
                    </div>

                    <input
                      type="text"
                      id="anyOfficeHeld"
                      name="anyOfficeHeld"
                      className="form-control"
                      disabled={
                        isAnyoneConsideredPEPHIOProspect &&
                        activeProduct.prospect?.PEPs[0].officeHeld
                      }
                      placeholder={
                        STRINGS.COMPLIANCE.FORM.OFFICE_HELD_PLACEHOLDER
                      }
                      value={anyOfficeHeld}
                      onChange={(event) => this.changeHandler(event)}
                    />
                    <div className="[ error-msg ] ">{anyOfficeHeldError}</div>
                  </div>
                )}
                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.JURISDICTION_LABEL}
                  </div>
                  <input
                    type="text"
                    id="anyJurisdiction"
                    name="anyJurisdiction"
                    className="form-control"
                    disabled={
                      isAnyoneConsideredPEPHIOProspect &&
                      activeProduct.prospect?.PEPs[0].jurisdiction
                    }
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.JURISDICTION_PLACEHOLDER
                    }
                    value={anyJurisdiction}
                    onChange={(event) => this.changeHandler(event)}
                  />
                  <div className="[ error-msg ] ">{anyJurisdictionError}</div>
                </div>

                <div className="[ mb-3 ]">
                  <div className="[ form-label ]">
                    {STRINGS.COMPLIANCE.FORM.SOURCE_OF_FUNDS_LABEL}
                  </div>
                  <input
                    type="text"
                    id="anySourceOfFunds"
                    name="anySourceOfFunds"
                    className="form-control"
                    disabled={
                      isAnyoneConsideredPEPHIOProspect &&
                      activeProduct.prospect?.PEPs[0].fundsSource
                    }
                    maxLength={40}
                    placeholder={
                      STRINGS.COMPLIANCE.FORM.SOURCE_OF_FUNDS_PLACEHOLDER
                    }
                    value={anySourceOfFunds}
                    onChange={(event) => this.changeHandler(event)}
                  />
                  <div className="[ error-msg ] ">{anySourceOfFundsError}</div>
                </div>
              </div>
            ) : null}

            {/* End HIO inner block */}
            {/* End HIO block */}
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ submit-btn btn ] [ w-100 ]"
                onClick={this.handleSubmit}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
    return (
      <>
        <AuthBody
          actionComponent={actionComponent}
          memberCreation
          handleBack={this.handleBack}
        />
        {showHelp && (
          <PopupModal
            type={AppConstants.MODALTYPE.INFORMATION}
            description={helpText}
            toggleModal={this.handleCloseHelp}
            showModal={showHelp}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}
      </>
    );
  }
}

Compliance.propTypes = {
  statusList: PropTypes.arrayOf(PropTypes.object).isRequired,
  accountPurposeArray: PropTypes.arrayOf(PropTypes.object).isRequired,
  indicateWhoArray: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleUpdateComplianceData: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  modal: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  getDataFromServer: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
  finInfo: PropTypes.objectOf(PropTypes.any),
  occupationCodes: PropTypes.arrayOf(PropTypes.object),
  incomeSourcesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  applicantData: PropTypes.oneOfType([PropTypes.object]),
};

Compliance.defaultProps = {
  getDataFromServer: () => {},
  steps: [],
  activeStepID: -1,
  finInfo: {},
  statusList: [],
  applicantData: null,
};

export default Compliance;
